import api from './api';

export const listLessons = async (params = {}) => {
  const { data } = await api.get('/lessons', { params });
  return data;
};

export const getLesson = async (id) => {
  const { data } = await api.get(`/lessons/${id}`);
  return data;
};

export const createLesson = async (payload) => {
  const formData = new FormData();
  Object.entries(payload || {}).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (key === 'files' && Array.isArray(value)) {
      value.forEach((file) => formData.append('files', file));
    } else if (key === 'videoFile' && value) {
      formData.append('videoFile', value);
    } else if (key === 'quiz' && typeof value === 'object') {
      formData.append('quiz', JSON.stringify(value));
    } else if (Array.isArray(value)) {
      value.forEach((item) => formData.append(`${key}[]`, item));
    } else {
      formData.append(key, value);
    }
  });
  const { data } = await api.post('/lessons', formData);
  return data;
};

export const updateLesson = async (id, payload) => {
  const formData = new FormData();
  Object.entries(payload || {}).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (key === 'files' && Array.isArray(value)) {
      value.forEach((file) => formData.append('files', file));
    } else if (key === 'videoFile' && value) {
      formData.append('videoFile', value);
    } else if (key === 'quiz' && typeof value === 'object') {
      formData.append('quiz', JSON.stringify(value));
    } else if (Array.isArray(value)) {
      value.forEach((item) => formData.append(`${key}[]`, item));
    } else {
      formData.append(key, value);
    }
  });
  const { data } = await api.put(`/lessons/${id}`, formData);
  return data;
};

export const deleteLesson = async (id) => {
  const { data } = await api.delete(`/lessons/${id}`);
  return data;
};

export default {
  listLessons,
  getLesson,
  createLesson,
  updateLesson,
  deleteLesson,
};
